import { Component, Input, ViewChild } from '@angular/core';
import { tap } from 'rxjs/operators';
import { ParametresService } from 'src/app/core/services/entities/parametres.service';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { AuthfakeauthenticationService } from 'src/app/core/services/authfake.service';
import { environment } from 'src/environments/environment';
import { FermeStateService } from 'src/app/core/services/entities/ferme-state.service';
import { Ferme } from 'src/app/core/models/ferme.model';
import { Observable } from 'rxjs';
import { RoleUtil, libellePostes } from 'src/app/shared/bay/role.util';
import { AffectationService, ModuleAffectation } from 'src/app/core/services/entities/affectation.service';
import { AbonnementService } from 'src/app/core/services/entities/abonnement.service';
import { SaisiesEnAttenteService } from 'src/app/core/services/entities/saisies-en-attente.service';
import { DepensesTerrainService } from 'src/app/core/services/entities/depenses-terrain.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
  /** Analyste : administrateurs et comptable (relu à chaque rendu, le rôle peut changer à la connexion) */
  get voitAnalyste(): boolean { return RoleUtil.voitFinances(); }
  get voitArticles(): boolean { return RoleUtil.redigeArticles(); }
  get estContenu(): boolean { return RoleUtil.estContenu(); }
  /** Agents de terrain : ni finances, ni clients, ni réglages (le serveur refuse aussi) */
  get estPersonnel(): boolean { return RoleUtil.estPersonnel(); }
  get gereExploitation(): boolean { return RoleUtil.gereExploitation(); }
  /** « Saisies à valider » : gestion ; le comptable y consulte les dépenses du personnel */
  get voitValidations(): boolean { return RoleUtil.gereExploitation() || RoleUtil.estComptable(); }
  /** Saisies du personnel à valider (badge) */
  aValider = 0;

  @Input() isCondensed = false;
  @ViewChild('componentRef') scrollRef: any;

  ferme$: Observable<Ferme | null>;
  /** Logo de la ferme servi par l'API (même règle que les PDF et le mobile) */
  logoSrc$: Observable<string>;
  logoCharge = false;

  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private authFackservice: AuthfakeauthenticationService,
    private fermeState: FermeStateService,
    private affectationService: AffectationService,
    private abonnementService: AbonnementService,
    private parametresService: ParametresService,
    private saisiesService: SaisiesEnAttenteService,
    private depensesService: DepensesTerrainService
  ) {
    this.ferme$ = this.fermeState.ferme;
    // Nouvelle adresse (logo changé ou retiré) : icône par défaut jusqu'au chargement de la nouvelle image
    this.logoSrc$ = this.parametresService.urlLogo().pipe(tap(() => this.logoCharge = false));
    // Lien « Plateforme » : super-admin seulement (le serveur refuse aussi)
    this.abonnementService.moi().subscribe({ next: m => this.superAdmin = !!m?.superAdmin, error: () => this.superAdmin = false });
    this.affectationService.mesModules$.subscribe(m => this.mesModules = m);
    this.affectationService.chargerMesModules();
    if (RoleUtil.gereExploitation()) {
      this.saisiesService.compte().subscribe({ next: c => this.aValider += c.enAttente, error: () => {} });
    }
    if (RoleUtil.gereExploitation() || RoleUtil.estComptable()) {
      this.depensesService.compte().subscribe({ next: c => this.aValider += c.enAttente, error: () => {} });
    }
  }

  superAdmin = false;

  /** Mes affectations (Personnel) */
  mesModules: ModuleAffectation[] = [];

  /** Le Personnel et le gestionnaire limité ne voient que leurs modules (comme le serveur) ; les autres rôles voient tout */
  voitModule(m: ModuleAffectation): boolean {
    return !(RoleUtil.estPersonnel() || RoleUtil.gestionnaireLimite()) || this.mesModules.includes(m);
  }

  /** Gestionnaire limité à ses postes : ni finances de la ferme, ni GED, ni réglages */
  get limite(): boolean { return RoleUtil.gestionnaireLimite(); }

  /** « Finances de Pisciculture » pour le gestionnaire limité */
  get libelleFinances(): string { return this.limite ? 'Finances de ' + libellePostes(this.mesModules) : 'Finance'; }

  logout() {
    if (environment.defaultauth === 'firebase') {
      this.authService.logout();
    } else {
      this.authFackservice.logout();
    }
    this.router.navigate(['/account/login']);
  }
}
